import React from "react";
import { topLogoUrl } from "../utils/constants-top-logo";

const HitachiTopLogo = () => {
  return (
    <svg
      className="top-vector"
      width="224"
      height="86"
      viewBox="0 0 224 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M45.5 86L0 0H223.5V86H45.5Z" fill="#454647" />
      <rect
        x="56"
        y="22"
        width="146"
        height="42"
        fill="url(#pattern0_620_793)"
      />
      <defs>
        <pattern
          id="pattern0_620_793"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_620_793"
            transform="matrix(0.00250149 0 0 0.00869565 -0.000297796 0)"
          />
        </pattern>
        <image
          id="image0_620_793"
          width="400"
          height="115"
          xlinkHref={topLogoUrl}
        />
      </defs>
    </svg>
  );
};

export default HitachiTopLogo;
